<template>
  <div
    class="i-ml-xl download-credit-insights"
    data-testid="download-credit-insights"
  >
    <i-menu close-on-item-click trigger-align="right" :width="217">
      <template #trigger>
        <i-button
          id="download-credit-insights-button"
          data-testid="download-credit-insights-button"
          text="Export"
          v-read-only-check
          icon
          icon-trailing
          type="primary"
          subtype="outline"
          size="md"
          icon-symbol="medium-chevron-down"
          :loading="isLoading"
        ></i-button>
      </template>

      <template #items>
        <i-menu-item
          label="Export Insights"
          class="menu-item"
          @item-click="exportInsights()" />
        <i-menu-item
          label="Export Transactions"
          class="menu-item"
          @item-click="exportTransactions()" />
        <i-menu-item label="Export All" @item-click="exportAll()"
      /></template>
    </i-menu>
  </div>
</template>

<script>
import axios from 'axios';
import { downloadBlob } from '@/utils/download';
import moment from 'moment';
import { iButton, iMenu, iMenuItem, showToast } from '@inscribe/signal';
import { getAndSyncQueryParams } from '@/utils/queryParams';
import { getUseAllDocsQueryParameter } from '@/V2/credit/utils';

export default {
  name: 'CreditInsightsExportButton',
  components: {
    iMenu,
    iMenuItem,
    iButton,
  },
  data() {
    return {
      isLoadingInsights: false,
      isLoadingTransactions: false,
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    isLoading() {
      return this.isLoadingInsights || this.isLoadingTransactions;
    },
    useAllDocsQueryParameter() {
      return getUseAllDocsQueryParameter(this.params);
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    async exportInsights() {
      this.isLoadingInsights = true;
      const params = {
        include_unreconciled_documents: this.useAllDocsQueryParameter,
      };

      return await axios
        .get(
          `/api/v2/customers/${this.$route.params.customer_id}/credit_insights_export`,
          { params },
        )
        .then((response) => {
          this.downloadCsv(
            response.data,
            'Inscribe Customer Credit Insights Export',
          );
        })
        .catch(() => {
          this.reportError('There was a problem exporting the Credit Insights');
        })
        .finally(() => {
          this.isLoadingInsights = false;
        });
    },
    async exportTransactions() {
      this.isLoadingTransactions = true;

      const params = {
        include_unreconciled_documents: this.useAllDocsQueryParameter,
      };
      return await axios
        .get(
          `/api/v2/customers/${this.$route.params.customer_id}/transactions/exports/csv`,
          { params },
        )
        .then((response) => {
          this.downloadCsv(
            response.data,
            'Inscribe Customer Transactions Export',
          );
        })
        .catch(() => {
          this.reportError('There was a problem exporting the transactions');
        })
        .finally(() => {
          this.isLoadingTransactions = false;
        });
    },
    async exportAll() {
      this.exportInsights();
      this.exportTransactions();
    },
    reportError(message) {
      showToast({
        title: message,
        text: 'Please try again',
        timeout: 10000,
        isError: true,
      });
    },
    downloadCsv(data, filename) {
      downloadBlob(
        data,
        `${filename} ${moment().format('YYYY-MM-DD')}.csv`,
        'text/csv',
      );
    },
  },
};
</script>
